import { Typography } from '@mui/material';
import styled, { css } from 'styled-components';

export const OptionWrapper = styled.div`
  display: flex;
  padding: 0 12px;
  gap: 6px;
  align-items: center;
`;

export const OptionNumber = styled(Typography)(
  ({ theme: { palette } }) => css`
    color: ${palette.grey[900]};
    font-size: 12px;
  `,
);

export const OptionLabel = styled(Typography)`
  font-size: 14px;
  font-weight: 700;
`;
